<template>
  <div class="bottomBar">
    <el-button v-if="isybClick==false" type="primary" circle @click="ybClick">预报</el-button>
    <el-button v-if="isybClick==true" type="success" circle @click="ybClick">预报</el-button>
    <el-button v-if="isyjClick==false" type="primary" circle @click="yjClick">预警</el-button>
    <el-button v-if="isyjClick==true" type="success" circle @click="yjClick">预警</el-button>
    <el-button v-if="isyyClick==false" type="primary" circle @click="yyClick">预演</el-button>
    <el-button v-if="isyyClick==true" type="success" circle @click="yyClick">预演</el-button>
    <el-button v-if="isyaClick==false" type="primary" circle @click="yaClick">预案</el-button>
    <el-button v-if="isyaClick==true" type="success" circle @click="yaClick">预案</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isybClick: true,
      isyjClick: false,
      isyyClick: false,
      isyaClick: false,
    };
  },
  mounted() {
    this.$emit('nowstatus', '预报');
  },
  methods: {
    fsClick() {
      this.$emit('picShow', true);
    },

    ybClick() {
      this.isybClick = true;
      this.isyjClick = false;
      this.isyyClick = false;
      this.isyaClick = false;
      this.$emit('nowstatus', '预报');
    },

    yjClick() {
      this.isybClick = false;
      this.isyjClick = true;
      this.isyyClick = false;
      this.isyaClick = false;
      this.$emit('nowstatus', '预警');
    },

    yyClick() {
      this.isybClick = false;
      this.isyjClick = false;
      this.isyyClick = true;
      this.isyaClick = false;
      this.$emit('nowstatus', '预演');
    },

    yaClick() {
      this.isybClick = false;
      this.isyjClick = false;
      this.isyyClick = false;
      this.isyaClick = true;
      this.$emit('nowstatus', '预案');
    },
  },
};
</script>

<style scoped>
.bottomBar {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%);
  height: 70px;
  /* background-color: aquamarine; */
  z-index: 1;
}
.fasong {
  position: absolute;
  left: 50%;
  bottom: 100px;
  transform: translate(-50%);
  z-index: 1;
}

>>> .el-button.is-circle {
  padding: 27px 20px;
}
</style>
